// Context Group Types
export type ContextGroupStatus = 'active' | 'inactive';

export interface TContextGroup {
  _id: string;
  name: string;
  instruction?: string;
  descriptionForTools?: string;
  countries?: string[];
  priority?: number;
  status: ContextGroupStatus;
  approved: boolean;
  parentGroup?: string | TContextGroup;
  childGroups?: TContextGroup[];
  itemCount?: number;
  childGroupCount?: number;
  characterCount?: number;
  createdAt?: string;
  updatedAt?: string;
  selected?: boolean
}

export interface TContextGroupCreate {
  name: string;
  instruction?: string;
  descriptionForTools?: string;
  countries?: string[];
  priority?: number;
  status?: ContextGroupStatus;
  approved?: boolean;
  parentGroup?: string;
}

export interface TContextGroupUpdate {
  name?: string;
  instruction?: string;
  descriptionForTools?: string;
  countries?: string[];
  priority?: number;
  status?: ContextGroupStatus;
  approved?: boolean;
}

export interface TContextGroupTree extends TContextGroup {
  children: TContextGroupTree[];
}

// Context Item Types
export type ContextItemStatus = 'active' | 'inactive';

export interface TContextItem {
  _id: string;
  question: string;
  content: string;
  instruction?: string;
  descriptionForTools?: string;
  referenceText?: string;
  linkToSource?: string;
  groups: string[] | TContextGroup[];
  countries?: string[];
  status: ContextItemStatus;
  approved: boolean;
  priority?: number;
  keywords?: string[];
  characterCount?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface TContextItemCreate {
  question: string;
  content?: string;
  instruction?: string;
  descriptionForTools?: string;
  referenceText?: string;
  linkToSource?: string;
  groups: string[];
  countries?: string[];
  status?: ContextItemStatus;
  approved?: boolean;
  priority?: number;
  keywords?: string[];
  file?: File;
}

export interface TContextItemUpdate {
  question?: string;
  content?: string;
  instruction?: string;
  descriptionForTools?: string;
  referenceText?: string;
  linkToSource?: string;
  groups?: string[];
  countries?: string[];
  status?: ContextItemStatus;
  approved?: boolean;
  priority?: number;
  keywords?: string[];
  file?: File;
}

export interface TContextItemSearch {
  question: string;
  groupIds?: string[];
  topN?: number;
}

export interface TContextItemSearchResult extends TContextItem {
  contextItem?: string;
  similarity?: number;
  score?: number;
  similarityScore?: number;
}

export interface TContextItemSearchResponse {
  question: string;
  results: TContextItemSearchResult[];
  count: number;
}

export interface TContextItemBatchCreate {
  items: TContextItemCreate[];
}

export interface TContextItemBatchResponse {
  created: TContextItem[];
  errors?: { index: number; error: string }[];
}

// Bot Context Assignment Types
export type ContextAssignmentTargetType = 'group' | 'item';
export type ContextAssignmentType = 'static' | 'dynamic' | 'tool' | 'forced';

export interface TContextAssignment {
  targetType: ContextAssignmentTargetType;
  targetId: string;
  assignmentType: ContextAssignmentType;
}

// Character count warning thresholds for static assignments
export const STATIC_ASSIGNMENT_WARNING_THRESHOLDS = {
  yellow: 10000, // ~2,500 tokens
  orange: 30000, // ~7,500 tokens
  red: 50000, // ~12,500 tokens
};

// API Response types
export interface TContextGroupApproveRequest {
  approved: boolean;
}

export interface TRegenerateEmbeddingsResponse {
  message: string;
  count?: number;
}
